import React from "react";
import { Download, FileText } from "lucide-react";
import { downloadCsv, downloadEntityPdf, downloadPdf } from "@/lib/exports";

/**
 * Canonical CSV + PDF export buttons.
 *
 * Preferred usage — pass a known `entity` and the current page rows:
 *   <ExportButtons entity="machinery" rows={rows} />
 * The button pulls its column definitions from `PDF_ENTITY_SPECS` so every
 * PDF looks identical no matter where in the app you clicked it. `csvEntity`
 * defaults to `entity` unless overridden.
 *
 * Back-compat — pages that need bespoke columns can still pass `pdfConfig`
 * (`{ title, rows, columns, filename }`) directly.
 */
const ExportButtons = ({
  entity,
  rows,
  csvEntity,
  csvFilename,
  pdfConfig,
  size = "sm",
  testidPrefix = "export",
}) => {
  const cls =
    size === "lg"
      ? "px-4 py-2.5 text-sm"
      : "px-2.5 py-1.5 text-xs";
  const csvKey = csvEntity || entity;
  const onPdf = () => {
    if (entity) return downloadEntityPdf(entity, rows);
    if (pdfConfig) return downloadPdf(pdfConfig);
  };
  return (
    <div className="flex items-center gap-2" data-testid={`${testidPrefix}-wrap`}>
      <button
        type="button"
        data-testid={`${testidPrefix}-csv-btn`}
        onClick={() => csvKey && downloadCsv(csvKey, csvFilename || csvKey)}
        className={`nb-btn bg-white ${cls} flex items-center gap-1.5 font-bold`}
        title="Download CSV"
      >
        <Download size={14} strokeWidth={2.5} />
        CSV
      </button>
      <button
        type="button"
        data-testid={`${testidPrefix}-pdf-btn`}
        onClick={onPdf}
        className={`nb-btn bg-[#FFF7D6] ${cls} flex items-center gap-1.5 font-bold`}
        title="Download PDF"
      >
        <FileText size={14} strokeWidth={2.5} />
        PDF
      </button>
    </div>
  );
};

export default ExportButtons;
